/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_Visit_To_PaidInputs */

const en_admin_funnel_col_visit_to_paid = /** @type {(inputs: Admin_Funnel_Col_Visit_To_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitor → paid`)
};

/**
* | output |
* | --- |
* | "Visitor → paid" |
*
* @param {Admin_Funnel_Col_Visit_To_PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_visit_to_paid = /** @type {((inputs?: Admin_Funnel_Col_Visit_To_PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_Visit_To_PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_visit_to_paid(inputs)
});
export { admin_funnel_col_visit_to_paid as "admin.funnel.col.visit_to_paid" }